/**
 * 模块: CompetitorTracker常量配置
 * 职责: 定义威胁等级配置等常量
 * 限制: 文件<280行
 */

import { WarningOutlined, InfoCircleOutlined, CheckCircleOutlined } from '@ant-design/icons';
import type { ThreatLevelConfig } from './types';

export const THREAT_LEVEL_CONFIGS: Record<string, ThreatLevelConfig> = {
  high: {
    color: 'red',
    text: '高威胁',
    icon: <WarningOutlined />,
    description: '该竞品频繁出现在Top3，需要重点关注',
  },
  medium: {
    color: 'orange',
    text: '中威胁',
    icon: <InfoCircleOutlined />,
    description: '该竞品偶尔出现在Top3，需要持续观察',
  },
  low: {
    color: 'green',
    text: '低威胁',
    icon: <CheckCircleOutlined />,
    description: '该竞品较少出现在Top3，威胁较小',
  },
};

export const getThreatLevelConfig = (level: string): ThreatLevelConfig => {
  return THREAT_LEVEL_CONFIGS[level] || THREAT_LEVEL_CONFIGS.low;
};

